export const NEUE_HAAS_GROTESK = `neue-haas-grotesk-display, sans-serif`;
